import { thunkProgress } from 'redux-progress';
import type { Dispatch, GetState } from 'model/State';
import {
  ORDERS_COUNT_BY_EMAIL,
  QUOTES_POST,
  LATEST_REFUND,
  REFUND_PDF,
  CART_JSON_GET,
  QUOTE_DELETE,
  CART_INVOICE_PDF,
  CART_PDF,
  PO_NUMBER_UPDATE_MODAL_OPEN,
  PO_NUMBER_UPDATE_MODAL_CLOSE,
  CART_CLONE_QUOTE,
} from './types';
import {
  ordersCountByEmail,
  latestRefund,
  quotes,
  refundPDF,
  singleQuote,
  cartJson,
  deleteQuote,
  cartInvoicePdf,
  cartPdf,
  cartCloneQuote,
} from '../../api';

export const fetchOrdersCountByEmail = () => (dispatch: Dispatch, getState: GetState) => {
  dispatch(thunkProgress(ORDERS_COUNT_BY_EMAIL, ordersCountByEmail(getState())));
};

export const fetchQuotesPost = (
  maxResults: number,
  offset: number,
  orderNumberMask?: number,
  technicalContactCompanyDomainName?: string,
  integerPartOfTotalAmount?: number,
) => (dispatch: Dispatch, getState: GetState) => {
  dispatch(
    thunkProgress(
      QUOTES_POST,
      quotes(
        getState(),
        maxResults,
        offset,
        orderNumberMask,
        technicalContactCompanyDomainName,
        integerPartOfTotalAmount,
      ),
    ),
  );
};

export const fetchSingleQuotePost = (orderId) => (dispatch: Dispatch, getState: GetState) => {
  dispatch(thunkProgress(QUOTES_POST, singleQuote(orderId, getState())));
};

export const fetchLatestRefund = (orderId: string) => (dispatch: Dispatch, getState: GetState) => {
  dispatch(thunkProgress(LATEST_REFUND, latestRefund(orderId, getState())));
};

export const fetchRefundPDF = (refundId: string) => (dispatch: Dispatch, getState: GetState) => {
  dispatch(thunkProgress(REFUND_PDF, refundPDF(refundId, getState())));
};

export const fetchCartInvoicePDF = (cartId: string) => (dispatch: Dispatch, getState: GetState) => {
  dispatch(thunkProgress(CART_INVOICE_PDF, cartInvoicePdf(cartId, getState())));
};

export const fetchCartPDF = (cartId: string) => (dispatch: Dispatch, getState: GetState) => {
  dispatch(thunkProgress(CART_PDF, cartPdf(cartId, getState())));
};

export const fetchCartJSON = (cartId: string) => (dispatch: Dispatch, getState: GetState) => {
  dispatch(thunkProgress(CART_JSON_GET, cartJson(cartId, getState())));
};

export const cloneQuote = (cartId: string) => (dispatch: Dispatch, getState: GetState) => {
  dispatch(thunkProgress(CART_CLONE_QUOTE, cartCloneQuote(cartId, getState())));
};

export const deleteCurrentQuote = (cartId: string, displayName: string) => (
  dispatch: Dispatch,
  getState: GetState,
) => {
  dispatch(thunkProgress(QUOTE_DELETE, deleteQuote(cartId, displayName, getState())));
};

export const openPONumberUpdateModal = (id: number, poNumber: string | null) => (
  dispatch: Dispatch,
) => {
  dispatch({ type: PO_NUMBER_UPDATE_MODAL_OPEN, id, poNumber });
};

export const closePONumberUpdateModal = (orderId: number) => (dispatch: Dispatch) => {
  dispatch({ type: PO_NUMBER_UPDATE_MODAL_CLOSE, orderId });
};
